import { useSelector } from 'react-redux'
import AppSnackbar from './AppSnackbar'
import { createLogger } from '../../../app/logger'
import {
  getSnackbarSelector,
  closeSnackbar
} from '../snackbarSlice'
import useAppDispatch from '../../../hooks/useAppDispatch'

const logger = createLogger({
  prefix: 'CheckinSnackbar'
})

const CheckinSnackbar = () => {
  const dispatch = useAppDispatch()
  const snackbar = useSelector(getSnackbarSelector)
  return (
    <AppSnackbar
      snackbar={snackbar}
      logger={logger}
      onSnackbarClose={() => {
        dispatch(closeSnackbar())
      }}
    />
  )
}

export default CheckinSnackbar
